import {
	alpha,
	Box,
	Card,
	CardActionArea,
	CardContent,
	Typography,
	useTheme
} from '@mui/material';
import { noop } from 'lodash';
import React, { FC } from 'react';
import { ITheme } from 'types/theme';
import { IWizardCombination, WizardAuthMethod } from 'types/wizard';
import { getWizardAuthMethodItemLabel } from '../utils/consts';

const CARD_WIDTH = 400;

interface IWizardCardProps {
	combination: IWizardCombination;
	onClick?: () => void;
	disabled?: boolean;
}

const WizardSuggestion: FC<IWizardCardProps> = ({
	combination,
	onClick,
	disabled
}) => {
	const { palette } = useTheme<ITheme>();
	const {
		previewImage,
		selected,
		primaryMethods: primary,
		secondaryMethod: secondary
	} = combination;

	const cardBorder = {
		border: `1px solid ${alpha(palette.primary.dark, 0.4)}`
	};

	const backgroundStyle = { background: palette.wizard.card.disabled };
	if (selected) {
		backgroundStyle.background = palette.wizard.card.light;
		cardBorder.border = `1px solid ${palette.primary.main}`;
	}

	return (
		<Card
			sx={{
				backgroundColor: palette.wizard.card.main,
				maxWidth: {
					xs: '100%',
					sm: CARD_WIDTH
				},
				height: '100%',
				...cardBorder
			}}
			elevation={0}
		>
			<CardActionArea
				onClick={onClick}
				data-testid="wizard-suggestion-card"
				disabled={disabled}
				sx={{
					height: '100%'
				}}
			>
				<CardContent
					sx={{
						height: '100%',
						...backgroundStyle,
						display: 'flex',
						flexDirection: 'column'
					}}
				>
					<Box height="130px" key={combination.preset}>
						<Box display="flex" flexDirection="column" flexGrow={1}>
							<Typography variant="overline" color="primary.main">
								{intl.tr('wizard.phase.build.suggestion.primaryMethods.label')}
							</Typography>
							<Typography variant="body1" color="text.primary">
								{(primary || [])
									.map((m) =>
										intl.tr(getWizardAuthMethodItemLabel(m as WizardAuthMethod))
									)
									.join(', ')}
							</Typography>
						</Box>
						<Box>
							<Typography variant="overline" color="secondary.main">
								{intl.tr(
									'wizard.phase.build.suggestion.secondaryMethods.label'
								)}
							</Typography>
							<Typography variant="body1" color="text.primary">
								{intl.tr(
									getWizardAuthMethodItemLabel(secondary as WizardAuthMethod)
								)}
							</Typography>
						</Box>
					</Box>
					<Box height="70%" pb={4}>
						<img src={previewImage} alt="login screen preview" loading="lazy" />
					</Box>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

WizardSuggestion.defaultProps = {
	onClick: noop,
	disabled: false
};

export default WizardSuggestion;
